
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalWest as ObiBuoyConicalWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-west.js';
 
 
 

 
 export const ObiBuoyConicalWest = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-west',
   elementClass: ObiBuoyConicalWestElement,
   events: {
     
   }
  });
 
 